import "./FoodTitulos.css";

export default function FoodTitulos({ title }) {
  return (
    <section className="frioTitulo-title">
      <h2>{title}</h2>
    </section>
  );
}
